import React from "react"
import PropTypes from "prop-types"
// Styles, images
import logo from "../../images/logo_white.png"
import { AvailableMenu } from "./Menu"
import { MenuProps } from "./types"
import * as styles from "./Styles/Header.module.scss"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)
import { Nav, Navbar } from "react-bootstrap"
import Icon from "../Utils/Icon"
import Support from "./Support"

const Header: React.FC<MenuProps> = (props) => {
  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      className={styles.header}
      bsPrefix="navigation--bar"
    >
      <Navbar.Toggle
        aria-controls="admin-menu"
        className={cn("toggle")}
        bsPrefix="navigation--toggle"
      >
        <Icon className={styles.noResult} type="feather" name="menu" />
      </Navbar.Toggle>
      <Navbar.Brand>
        <img src={logo} className={styles.logo} />
      </Navbar.Brand>
      <Navbar.Collapse id="admin-menu">
        <Nav>
          {AvailableMenu(props.availableMenus).map((m) => (
            <div className={styles.headerContentWrapper} key={m.key}>
              <Nav.Link
                href={props.paths[m.key]}
                className={cn("navigations", {
                  selected: props.selected == m.key,
                })}
                bsPrefix="navigation--link"
                target={m.suffixIcon ? "_blank" : ""}
              >
                <div
                  className={cn(
                    "headerContent",
                    "l-flex",
                    "l-flex-align-center"
                  )}
                >
                  {m.icon(styles.headerIcon)}
                  <span>{m.title}</span>
                  {m.suffixIcon && m.suffixIcon(styles.suffixIcon)}
                </div>
              </Nav.Link>
            </div>
          ))}
        </Nav>
        <hr />
        <Support />
      </Navbar.Collapse>
    </Navbar>
  )
}
Header.propTypes = {
  paths: PropTypes.object,
}
export default Header
